import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import * as api from '../../services/api';
import Select2 from '../../../components/shared/select2';
import * as blockui from '../../../helpers/block-ui';
import * as swal from '../../../helpers/swal';

export default {
  props: {
    user: {
      default() {
        return {};
      },
      type: Object,
    },
    isUpdate: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return { };
  },
  components: {
    select2: Select2,
  },
  computed: {
    ...mapState({
        userExcuseList: (state) => state.excuse.userExcuseList
    }),
    ...mapGetters({
      getDocumentStatusText: 'getDocumentStatusText',
      getDocumentValidityStatusText: 'getDocumentValidityStatusText',
    }),
  },
  created() {
  },
  async mounted() {
    const self = this;
    await self.initData();
    mApp.initScrollers();
  },
  methods: {
    deleteItem(index) {
      const self = this;
      const id = self.userExcuseList[index].Id;
      swal.check(self, 'Girilmiş izni silmek istediğinizden emin misiniz?').then((e) => {
        if (e.value) {
          api.deleteUserExcuse(id).then((response) => {
            if (response.body.IsSuccess) {
              toastr.success(self.translate('delete_successfully'));
              self.initData();
            } else {
              toastr.error(response.body.Message);
            }
          });
        }
      });
    },
    editItem(index) {
      this.$parent.$parent.editItem('userExcuse', this.userExcuseList[index].Id);
    },
    async initData() {
      const self = this;
      await self.$store.dispatch('getUserExcuseList', self.user.Id);
    },
    formatMinToHour(duration) {
      const hour = parseInt(duration / 60);
      const minute = duration % 60;

      const hourText = hour > 0 ? `${hour} saat ` : '';
      const minuteText = minute > 0 ? `${minute} dakika` : '';

      return `${hourText}${minuteText}`;
    }
  },
  watch: {
    userExcuseList(e) {
      if (e) {
        Vue.set(this.$parent, 'userExcuseCount', e.length);
      }
    },
  },
};
